"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var rurallure_microservices_alerts_decoder_1 = require("rurallure-microservices-alerts-decoder");
var PlannerForm = /** @class */ (function (_super) {
    __extends(PlannerForm, _super);
    function PlannerForm() {
        var _this = _super.call(this) || this;
        _this.loader = false;
        _this.coordinatesError = false;
        _this.commonValidationError = false;
        _this.commonValidationErrorMessage = "";
        _this.availableTransports = [];
        _this.waitingForResponse = false;
        _this.originCoordinates = null;
        _this.destinationCoordinates = null;
        _this.transportSelected = null;
        _this.suitableForSelected = null;
        _this.preferencesSelected = [];
        _this.partnership = null;
        _this.dateRange = {
            start: null,
            end: null
        };
        return _this;
    }
    PlannerForm.prototype.beforeCreate = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a, _b, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loader = true;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 6]);
                        _a = this;
                        return [4 /*yield*/, this.$getAllTransportsService.request()];
                    case 2:
                        _a.availableTransports = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this.$getPartnershipDataService.request(this.$route.params.partnershipSlug)];
                    case 3:
                        _b.partnership = _c.sent();
                        this.loader = false;
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _c.sent();
                        return [4 /*yield*/, this.$router.push({ name: 'error', params: { code: error_1.response.status.toString() } })];
                    case 5:
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    PlannerForm.prototype.submit = function () {
        var _this = this;
        this.resetErrors();
        this.requestValidation();
        if (this.commonValidationError || this.coordinatesError) {
            return;
        }
        this.waitingForResponse = true;
        var requestBody = this.generateRequestBody();
        this.$newPlanService.request(requestBody).then(function (response) {
            _this.process_response(response, requestBody);
        }, function (error) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$router.push({ name: 'error', params: { code: error.response.status } })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    PlannerForm.prototype.process_response = function (response, requestBody) {
        var _a, _b, _c, _d;
        if (((_a = response.alerts) === null || _a === void 0 ? void 0 : _a.problems) !== undefined && ((_b = response.alerts) === null || _b === void 0 ? void 0 : _b.problems.length) > 0) {
            var alertDecoder = new rurallure_microservices_alerts_decoder_1.AlertDecoder(this.$i18n.locale);
            this.commonValidationErrorMessage = alertDecoder.decode(response.alerts.problems[0].code);
            this.waitingForResponse = false;
            this.commonValidationError = true;
            return;
        }
        if (((_c = response.alerts) === null || _c === void 0 ? void 0 : _c.warnings) !== undefined && ((_d = response.alerts) === null || _d === void 0 ? void 0 : _d.warnings.length) > 0) {
            response.alerts.warnings.forEach(function (w_alert) {
                if (w_alert.code === 'PL-2-0') {
                    requestBody.start_gps_latitude = w_alert.params["0"]["value"]["coordinates"][1];
                    requestBody.start_gps_longitude = w_alert.params["0"]["value"]["coordinates"][0];
                }
                if (w_alert.code === 'PL-2-1') {
                    requestBody.end_gps_latitude = w_alert.params["0"]["value"]["coordinates"][1];
                    requestBody.end_gps_longitude = w_alert.params["0"]["value"]["coordinates"][0];
                }
            });
        }
        this.$browserStorage.setPersistLevelSession(true).set('planner_response', response);
        this.$browserStorage.setPersistLevelSession(true).set('planner_request', requestBody);
        this.onRequestPlannerSuccess();
    };
    PlannerForm.prototype.requestValidation = function () {
        if (this.originCoordinates === null || this.destinationCoordinates === null) {
            this.coordinatesError = true;
        }
        if (this.dateRange.start === null) {
            this.commonValidationErrorMessage = this.$t('validation.dateFrom');
            this.commonValidationError = true;
        }
    };
    PlannerForm.prototype.resetErrors = function () {
        this.coordinatesError = false;
        this.commonValidationError = false;
        this.commonValidationErrorMessage = "";
    };
    PlannerForm.prototype.generateRequestBody = function () {
        return __assign({ partnership_slug: this.$route.params.partnershipSlug, start_gps_longitude: this.originCoordinates.lng, start_gps_latitude: this.originCoordinates.lat, end_gps_longitude: this.destinationCoordinates.lng, end_gps_latitude: this.destinationCoordinates.lat, date_from: this.dateRange.start, date_to: (this.dateRange.end || this.dateRange.start), transport: this.transportSelected, traveling_hours_per_day: 8, preferences: this.preferencesSelected, planning_algorithm: "" }, (this.suitableForSelected && { suitable_for: this.suitableForSelected }));
    };
    return PlannerForm;
}(vue_1.default));
exports.default = PlannerForm;
